export default __webpack_public_path__ + "static/media/logoOfficial.6bfe9b1e.jpg";